import { render, staticRenderFns } from "./TeacherReg.vue?vue&type=template&id=05ce3401&scoped=true&"
import script from "./TeacherReg.vue?vue&type=script&lang=js&"
export * from "./TeacherReg.vue?vue&type=script&lang=js&"
import style0 from "./TeacherReg.vue?vue&type=style&index=0&id=05ce3401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ce3401",
  null
  
)

export default component.exports